import React, { useState, useEffect } from "react"

import { Container, Header, Body, Input, Card, SearchContainer, Select, Result, Headline, CardContainer, Thumb, Image, Rating, Info, Title, Date } from "./styles/search"
import { Container as MainContainer } from "../../containers"
import { Icon } from "../../components"
import Color from "../../constants/Color"

export default function Search({ children, ...rest }) {
  return <Container {...rest}>{children}</Container>
}

Search.Header = function ({ children, ...rest }) {
  return (
    <Header {...rest}>
      <MainContainer>{children}</MainContainer>
    </Header>
  )
}

Search.Body = function ({ children, title, prev, isLoading, ...rest }) {
  return (
    <Result {...rest}>
      <MainContainer>
        {title ? <Headline>Search Result</Headline> : ""}
        {prev && !isLoading && !title ? <Headline>Previus Result</Headline> : ""}
        {isLoading ? <Headline>Searching....</Headline> : ""}
        <Body>{children}</Body>
      </MainContainer>
    </Result>
  )
}

Search.SearchContainer = function ({ children, ...rest }) {
  return <SearchContainer {...rest}>{children}</SearchContainer>
}

Search.SearchBy = function ({ ...rest }) {
  return (
    <Select id="by" name="by" {...rest}>
      <option value="movie">Movie</option>
      <option value="tv">Tv Show</option>
    </Select>
  )
}

Search.Input = function ({ children, ...rest }) {
  return <Input {...rest} placeholder="Search" />
}

Search.Card = function ({ children, ...rest }) {
  return <Card {...rest}>{children}</Card>
}

Search.MovieCard = function MovieCard({ children, to, rest }) {
  return (
    <CardContainer to={to} {...rest}>
      {children}
    </CardContainer>
  )
}

Search.Thumb = function MovieCardThumb({ children, rate, rest }) {
  const [color, setColor] = useState("")
  let number = parseInt(rate)
  useEffect(() => {
    if (number < 4) {
      setColor((prev) => Color.bad)
    } else if (number > 3.9 && number < 7) {
      setColor((prev) => Color.ok)
    } else if (number > 6.9 && number < 8) {
      setColor((prev) => Color.great)
    } else if (number > 7.9) {
      setColor((prev) => Color.superb)
    }
  }, [number])
  return (
    <Thumb {...rest} color={color}>
      {children}
    </Thumb>
  )
}
Search.Rating = function MovieCardRating({ rate, count, rest }) {
  const [color, setColor] = useState("")
  const [bgColor, setBgColor] = useState()
  let number = parseInt(rate)
  useEffect(() => {
    if (rate && number < 4) {
      setColor((prev) => Color.bad)
      setBgColor(Color.badBg)
    } else if (number > 3.9 && number < 7) {
      setColor((prev) => Color.ok)
      setBgColor(Color.okBg)
    } else if (number > 6.9 && number < 8) {
      setColor((prev) => Color.great)
      setBgColor(Color.greatBg)
    } else if (number > 7.9) {
      setColor((prev) => Color.superb)
      setBgColor(Color.superbBg)
    } else {
      setColor(Color.white)
    }
    // eslint-disable-next-line
  }, [number])

  return (
    <Rating {...rest} bg={bgColor} count={count} color={color}>
      {count ? "" : <Icon name="ph-star-fill" pt="1" mr="4" color={color} />}
      <p>{rate || count}</p>
    </Rating>
  )
}

Search.Image = function MovieCardImage({ path, rest }) {
  return <Image src={path} {...rest} />
}

Search.Info = function MovieCardInfo({ children, isTv, rest }) {
  return (
    <Info {...rest} isTv={isTv}>
      {children}
    </Info>
  )
}

Search.Title = function MovieCardTitle({ children, rest }) {
  return <Title {...rest}>{children}</Title>
}

Search.Date = function MovieCardDate({ children, rest }) {
  return <Date {...rest}>{children}</Date>
}
